export enum UserStatus {
    PENDING = 'Pending',
    ACTIVE = 'Active',
    BLOCKED = 'Blocked',
}
